<script lang="ts">
	//UI
	import { Card, DefaultLoading } from "@hitit/new_ui";
	import PlainTextEditor from "@hitit/hub/src/components/place/PlainTextEditor.svelte";
	//Utils
	import { api, t } from "@hitit/hub/src/stores";

	//Types
	//Props
	export let storeId = "";
	export let text = "";
	//Constants
	const textEditorProps = {
		lengthLimit: Infinity,
		lineLimit: Infinity,
		value: text,
		placeholder: $t("mbr.store.memo_placeholder"),
	};
	//Variables
	let timeout: any;
	let loading = false;
	//Functions
	async function changeHandler(e: { detail: { html: string } }) {
		if (timeout) {
			clearTimeout(timeout);
		}

		timeout = setTimeout(async () => {
			try {
				loading = true;
				await $api.postAdminComment(storeId, e.detail.html);
				//
			} catch (error) {
				console.log(error);
			} finally {
				loading = false;
			}
		}, 500);
	}
	//Do

</script>

<Card noPadding>
	<div class="container">
		<p class="title">{$t('mbr.store.memo')}</p>
		<div class="editor">
			<PlainTextEditor {...textEditorProps} on:UPDATE_TEXT={changeHandler} />
		</div>
		{#if loading}
			<div class="loading">
				<DefaultLoading />
			</div>
		{/if}
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
		position: relative;
		padding: 20px 10px;
		gap: 10px;
		.title {
			color: #46474b;
			font-size: 1.25rem;
			font-weight: 600;
		}

		.editor {
			:global(.plainTextEditor .ql-editor) {
				min-height: 150px;
				position: relative;
				box-sizing: border-box;
				border-style: none;
				border-radius: 5px;
				padding: 10px;
				overflow: auto;
				background-color: #f0f0f4;
				line-height: 30px;
				color: #46474b;
			}
			:global(.plainTextEditor .ql-editor:focus) {
				outline: 0px solid transparent;
			}

			:global(.plainTextEditor .ql-editor.ql-blank::before) {
				color: #bcbfc3;
				content: attr(data-placeholder);
				position: absolute;
				top: 0px;
				left: 10px;
			}
		}

		.loading {
			width: 20px;
			height: 20px;
			position: absolute;
			top: 10px;
			right: 20px;
		}
	}

	@include DesktopSize {
		.container {
			padding: 30px;
			gap: 30px;
			.title {
				font-size: 2.1875rem;
			}

			.editor {
				:global(.plainTextEditor .ql-editor) {
					font-size: 1.25rem;
				}
			}
			.loading {
				width: 30px;
				height: 30px;
				position: absolute;
				top: 30px;
				right: 30px;
			}
		}
	}

</style>
